import { useCallback } from 'react';

import { SourceType } from 'src/generated/mloop-graphql';

import { useApolloRefetchQuery } from 'src/hooks/useApolloQuery';

export function useActivityFeedRefetch(sourceType?: SourceType) {
  const refetchQuery = useApolloRefetchQuery();

  const refetch = useCallback(() => {
    if (!sourceType) {
      return refetchQuery([
        'TaskDetailsActivityLogsList',
        'ApplicationDetailsActivityLogsList',
        'EntityDetailsActivityLogsList',
      ]);
    }

    if (sourceType === SourceType.SourceTypeTask) {
      return refetchQuery(['TaskDetailsActivityLogsList']);
    }

    if (sourceType === SourceType.SourceTypeApplication) {
      return refetchQuery(['ApplicationDetailsActivityLogsList']);
    }

    return refetchQuery(['EntityDetailsActivityLogsList']);
  }, [refetchQuery, sourceType]);

  return refetch;
}

export function useTaskTimelineActivityFeedRefetch() {
  const refetchQuery = useApolloRefetchQuery();

  return useCallback(() => refetchQuery(['TaskTimelineActivityLogsList']), [refetchQuery]);
}
